var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.498 3.498L12.502.502C12.181.181 11.745 0 11.29 0H1.714C.767 0 0 .767 0 1.714v12.572C0 15.233.767 16 1.714 16h12.572c.947 0 1.714-.768 1.714-1.714V4.71c0-.455-.18-.89-.502-1.212zM9.714 1.714v2.857H5.143V1.714h4.571zm4.357 12.572H1.93c-.119 0-.215-.096-.215-.215V1.93c0-.119.096-.215.215-.215h1.5V5.43c0 .473.383.857.857.857h6.285c.474 0 .858-.384.858-.857V1.853l2.794 2.794c.04.04.063.095.063.152v9.272c0 .119-.096.215-.215.215zM8 7.143c-1.733 0-3.143 1.41-3.143 3.143 0 1.733 1.41 3.143 3.143 3.143 1.733 0 3.143-1.41 3.143-3.143 0-1.733-1.41-3.143-3.143-3.143zm0 4.571c-.788 0-1.429-.64-1.429-1.428 0-.788.641-1.429 1.429-1.429s1.429.641 1.429 1.429c0 .787-.641 1.428-1.429 1.428z",
    transform: "translate(-760 -218) translate(40 218) translate(720) translate(4 4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.2698dd23.svg";
export { ForwardRef as ReactComponent };